// HATA AYIKLAMA SÜRÜMÜ

console.log('[Wishlist] Script dosyası başarıyla yüklendi ve çalışmaya başladı.');

const updateWishlistButtonState = (button, productHandle, wishlist) => {
  if (!button) return;
  
  const buttonTextElement = button.querySelector('.wishlist-text');
  
  if (wishlist.includes(productHandle)) {
    button.classList.add('active');
    if (buttonTextElement) buttonTextElement.textContent = 'İstek Listesinde';
  } else {
    button.classList.remove('active');
    if (buttonTextElement) buttonTextElement.textContent = 'İstek Listesine Ekle';
  }
};

const initializeWishlistButtons = () => {
  console.log('[Wishlist] initializeWishlistButtons fonksiyonu çalıştırıldı.');
  
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  console.log(`[Wishlist] Sayfada ${wishlistButtons.length} adet ".wishlist-btn" class'ına sahip buton bulundu.`);

  if (wishlistButtons.length === 0) {
    console.warn('[Wishlist] Uyarı: Sayfada hiç istek listesi butonu bulunamadı. Butonun class adının "wishlist-btn" olduğundan emin misiniz?');
    return;
  }

  let wishlist = JSON.parse(localStorage.getItem('shopify-wishlist')) || [];

  wishlistButtons.forEach(button => {
    if (button.dataset.wishlistInitialized) return;
    
    const productHandle = button.dataset.productHandle;
    if (!productHandle) {
      console.error('[Wishlist] Hata: Bir butonda "data-product-handle" eksik!', button);
      return;
    }

    console.log(`[Wishlist] Buton için event listener ekleniyor: ${productHandle}`);
    updateWishlistButtonState(button, productHandle, wishlist);

    button.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(`[Wishlist] Butona tıklandı: ${productHandle}`);
      
      wishlist = JSON.parse(localStorage.getItem('shopify-wishlist')) || [];
      const handleIndex = wishlist.indexOf(productHandle);

      if (handleIndex > -1) {
        wishlist.splice(handleIndex, 1);
        console.log(`[Wishlist] Ürün listeden çıkarıldı: ${productHandle}`);
      } else {
        wishlist.push(productHandle);
        console.log(`[Wishlist] Ürün listeye eklendi: ${productHandle}`);
      }

      localStorage.setItem('shopify-wishlist', JSON.stringify(wishlist));
      
      document.querySelectorAll(`.wishlist-btn[data-product-handle="${productHandle}"]`).forEach(btn => {
        updateWishlistButtonState(btn, productHandle, wishlist);
      });

      if (window.location.pathname.includes('/pages/istek-listem') && handleIndex > -1) {
         const cardToRemove = button.closest('.wishlist-product-card');
         if (cardToRemove) cardToRemove.remove();
         
         if (wishlist.length === 0) {
             const emptyMsg = document.getElementById('wishlist-empty-message');
             const clearBtn = document.getElementById('clear-wishlist');
             if (emptyMsg) emptyMsg.style.display = 'block';
             if (clearBtn) clearBtn.style.display = 'none';
         }
      }
    });

    button.dataset.wishlistInitialized = 'true';
  });
};

document.addEventListener('DOMContentLoaded', initializeWishlistButtons);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      initializeWishlistButtons();
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });